const theme = {
  colors: {
    primary: "#243b5e",
    secondary: "#50e5fe",
  },
  dark: {
    colors: {
      primary: "#50e5fe",
      secondary: "#9fadc2",
    },
  },
  light: {
    colors: {
      primary: "#243b5e",
      secondary: "#50e5fe",
    },
  },
};

export default theme;
